import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
import { convertJsonToFormData } from '../commonfunctions';

export const getHoas = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/hoas', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchHoa = async (tagId, callback) => {
    try {
        const response = await risapi.get(`/api/hoas/${tagId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createHoa = async (newHoa, callback) => {
    try {
        const formData = convertJsonToFormData(newHoa);
        const response = await risapi.post('/api/hoas', formData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const updateHoa = async (editHoa, callback) => {
    try {
        const formData = convertJsonToFormData(editHoa);
        formData.append('_method', 'put');
        
        const response = await risapi.post(`/api/hoas/${editHoa.id}`, formData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback(error.response.data);
    }
};

export const destroyHoa = async (deleteHoa, callback) => {
    try {
        const response = await risapi.delete(`/api/hoas/${deleteHoa.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ hoa: deleteHoa });
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }

};


export const destroyHoasMultiple =  async (ids,callback) => {
  
    try {
     
        var sendData = {};
        sendData.ids = ids;
        sendData._method = 'delete';
        const response = await risapi.post('/api/hoas/delete/multiple',sendData,getAxiosConfig());

        console.log("delete multiple response",response);
        
        if (response.status === 204) {
            callback({hoa:ids});
        }
    } catch (error) {
        callback(error);
    }
}
